import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { PlanOverview } from "@/features/billing/components/plan-overview";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Plan/subscription screen (MONETIZATION_QUOTAS, B2B per seat).
 * URL-addressable: /u/$u/profile/plan. With monetization OFF it shows the
 * PlanOverview empty state (the profile link does not even appear).
 */
function ProfilePlanPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="2xl">
      <PageHeader title={t(msg`Plan & usage`)} backTo="/profile" />
      <PlanOverview />
    </PageContainer>
  );
}

export const profilePlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/plan",
  component: ProfilePlanPage,
});
